import { Link } from "react-router-dom";
import { allCategories } from "@/lib/news";

export default function CategoryGrid() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-6">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            按类型浏览黑料信息，快速定位您关注的内容方向。
          </p>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {allCategories.map((category, index) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 animate-fade-up cursor-pointer"
              style={{ animationDelay: `${index * 60}ms` }}
            >
              <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md">
                <img
                  src={category.image}
                  alt={`${category.name}分类配图`}
                  title={`${category.name}分类`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <i className={`${category.icon} text-lg text-accent-600`} />
                  <h3 className="font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {category.name}
                  </h3>
                </div>
                <p className="mt-1 line-clamp-2 text-xs leading-5 text-foreground-500">
                  {category.description}
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-xl text-foreground-300 transition-colors group-hover:text-primary-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}